<template>
    <!--
        作者：kmdshop
        时间：2019-10-24
        描述：sku管理
    -->
    <div class="product-list">
      <!--搜索表单-->

      <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
  
        <el-form-item label="流向记录条形码"><el-input size="small" v-model="searchForm.cno_search" 
          placeholder="请输入流向记录条形码"></el-input></el-form-item>

        <el-form-item label="sku条形码/规格"><el-input size="small" v-model="searchForm.sku_search" 
            placeholder="请输入sku条形码/规格"></el-input></el-form-item>
        
            <el-form-item label="发出人">
          <el-input size="small" v-model="searchForm.send_search" placeholder="请输入发出人昵称/手机号"></el-input>
        </el-form-item>

        <el-form-item label="接收人">
          <el-input size="small" v-model="searchForm.receive_search" placeholder="请输入接收人昵称/手机号"></el-input>
        </el-form-item>

        <el-form-item label="发出/接收人">
          <el-input size="small" v-model="searchForm.sr_search" placeholder="请输入发出/接收人昵称/手机号"></el-input>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        
            <el-form-item>
               <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>

                <el-button size="small"  icon="el-icon" @click="resat">重置</el-button>
            </el-form-item>
      </el-form>
    </div>


    <div class="product-content"  v-if="tableData.length >0">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%;" v-loading="loading" 
        @selection-change="handleSelectionChange">
          <el-table-column type="selection"  width="45"></el-table-column>
          <el-table-column  width="45">
            <template slot-scope="scope" >
                {{ scope.$index+1 }}
            </template>
          </el-table-column>
          <el-table-column prop="code_no" label="流向记录条形码" ></el-table-column>
               
          <el-table-column prop="product_name" label="产品" width="200px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image?scope.row.image:''" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.sku.product_name }}</div>
                  <div class="price">￥{{ scope.row.sku.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          
          <el-table-column  label="发出人" width="200">
            <template slot-scope="scope">
                 <div>身份：{{ scope.row.sendidobj.code_text }}</div>
                 <div>名称/姓名：{{ scope.row.sendidobj.name }}</div>
                 <div v-if="scope.row.sendidobj.mobile">手机号：{{ scope.row.sendidobj.mobile }}</div>
            
                </template>
          </el-table-column>

          <el-table-column  label="接收人" width="200">
            <template slot-scope="scope">
                 <div>身份：{{ scope.row.idobj.code_text }}</div>
                 <div>名称/姓名：{{ scope.row.idobj.name }}</div>
                 <div v-if="scope.row.idobj.mobile">手机号：{{ scope.row.idobj.mobile }}</div>
     
                </template>
          </el-table-column>


          <el-table-column prop="num" label="数量" width="60"></el-table-column>
        
  
 
          <el-table-column prop="spec_value" label="规格" width="60"></el-table-column>
          <el-table-column prop="product_no" label="条形码"  width="80"></el-table-column>
 
          <el-table-column prop="sku.product_price" label="价格" width="60"></el-table-column>
   
          <el-table-column prop="create_time" label="流向时间" ></el-table-column>
   
<!-- 
          <el-table-column prop="price_type" label="价格类型" >
            <template slot-scope="scope">
                
            <el-radio-group v-model="scope.row.sku_prices.price_type">
                <el-radio  :label="1" >固定</el-radio>
                <el-radio  :label="2">比例</el-radio>
            </el-radio-group>
          
            </template>
          </el-table-column> -->

        
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button  type="primary" @click="editClick(scope.row)"  size="small" >详情</el-button>
              
            </template>
          </el-table-column> 
            
    
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination" v-if="tableData.length >0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <div style="height: 30px;"></div>


    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="maKeSkuPriceS" :disabled="loading">详情</el-button>
    </div>


    </div>
  </template>
  
  <script>
  import ProductApi from '@/api/product.js';
  import qs from 'qs';

  export default {
    components: {

    },
    data() {
      return {
        isupload:false,
        /*切换菜单*/
        activeName: 'all',
        /*切换选中值*/
        activeIndex: '0',
        /*是否正在加载*/
        loading: true,
        /*一页多少条*/
        pageSize: 15,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          cno_search:"A10000",
          sku_search:"54997",
          user_search:"",
          send_search:"",
          sr_search:""
        },
        /*列表数据*/
        tableData: [],
        //用户数据
        userTableData:[],
        /*选中的*/
        multipleSelection: [],
        /*选择的商品列表*/
        select_list:[],
        /*是否显示*/
        dialogVisible: false,
        // 是否加载操作页面
        more_actions:false,
        product_no_search:'',
        is_open_wholesale:false,
        curModel:{},
        is_open_scp:false,
        product_sku:{},
        showCheckStock:false,
        multipleSelection:[],
        form:{
            min_shipment:0,
            max_shipment:0,
            price:0,
            price_type:1,
        }
      };
    },
    created() {
      /*获取列表*/
      this.getData();
  
    },
    methods: {
        roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        return this.roundToDecimalPlace(price,2)
      },
            /*选择sku*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },
    maKeSkuPriceS(){//批量设置价格
        var self = this;
        self.loading = true;
        var Params = {};
        if(this.multipleSelection.length <= 0){
            self.loading = false;
            self.$message({
                    message: '请选择要定价的sku',
                    type: 'error'
                    });
           return; 
        }
        Params.parmas = JSON.stringify(self.multipleSelection);
        Params.user_id = self.userTableData[0].user_id

        ProductApi.maKeSkuPrice(Params, true)
          .then(data => {
            self.loading = false;
            if(data.code == 1){

                self.$message({
                    message: '恭喜你，设置成功',
                    type: 'success'
                    });
            }
          })
          .catch(error => {
            self.loading = false;
          });  
    },
    maKeSkuPrice(row){
        var self = this;
        self.loading = true;
        var Params = {};
        Params.parmas = JSON.stringify([row]);
        Params.user_id = self.userTableData[0].user_id

        ProductApi.maKeSkuPrice(Params, true)
          .then(data => {
            self.loading = false;
            if(data.code == 1){

                self.$message({
                    message: '恭喜你，设置成功',
                    type: 'success'
                    });
            }
          })
          .catch(error => {
            self.loading = false;
          });   
    },
   
      uploadPNI(row){
          this.curModel = row
          this.isupload = true;
      },
      checkStock(row){//盘点库存
        this.showCheckStock = true
        this.curModel = row;
      },
      editAdd(e){
        console.log(e)
        this.is_open_scp = true;
        this.product_sku = e
  
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.loading = true;
        self.curPage = val;
        self.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },
  
      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
  
      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.type = self.activeName;
        self.loading = true;
        ProductApi.getSkuFlow(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.sku.data;
            self.totalDataNumber = data.data.sku.total;

            self.userTableData =  data.data.user;
          })
          .catch(error => {
            self.loading = false;
          });
      },
  
      /*打开编辑*/
      setWholesale(row){
          this.is_open_wholesale =true;
          this.curModel = row;
      },
      resat(){
      this. searchForm =  {
          sku_search:this. searchForm.sku_search,
          user_search:"",
          send_search:"",
          sr_search:""
        }
        this.curPage = 1;
        this.getData();
      },
      onSubmit(){
        this.curPage = 1;
        this.getData();
      },
      closeDialogFunc(e) {
       
  
          this.is_open_wholesale = e.openDialog;
          this.is_open_scp = e.openDialog;
          this.showCheckStock = e.openDialog
          if (e.type == 'success') {
              this.getData();
          }
  
          
      },
      checkAdd(item){
        this.$router.push({
            path: '/plus/psin/index/skustock',
            query: {
              product_sku_id: item.product_sku_id
            }
          });
      },
  
   
      
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/product/sku/sku_flow.vue